import React, { useState } from 'react';
import { Survey } from 'survey-react-ui';
import { Model } from 'survey-core';

import FadeIn from 'legacy/common/components/transition/FadeIn';
import {
  useGetRequestToPublishForm,
  useSubmitRequestToPublishForm
} from '../../hooks';
import Redirect from '../../../components/util/Redirect/Redirect';
import Loader from '../../../common/components/layout/Loader';
import { Theme } from 'theme/survey-js/theme';

import 'survey-core/defaultV2.min.css';

interface RequestToPublishProps {
  requestToPublishFormId: string;
  requestPublication: (data: { responseId: string }) => void;
}

const RequestToPublishForm: React.FC<RequestToPublishProps> = ({
  requestToPublishFormId,
  requestPublication
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data, isLoading, isError } = useGetRequestToPublishForm(
    requestToPublishFormId
  );

  const submitForm = useSubmitRequestToPublishForm();

  const onSubmit = ({ data }) => {
    setIsSubmitting(true);
    submitForm.mutate(
      {
        formId: requestToPublishFormId,
        body: data
      },
      {
        onSuccess: (res) => {
          requestPublication({ responseId: res.id });
        }
      }
    );
  };

  if (isLoading || isSubmitting) {
    return <Loader isLoading />;
  }

  if (isError || !data.id) {
    return <Redirect to="/404" />;
  }

  const survey = new Model(data.schema);
  survey.applyTheme(Theme);
  survey.onComplete.add(onSubmit);

  return (
    <FadeIn>
      <div className="pt-[50px] md:pt-[120px] -mt-[90px] pb-20">
        <Survey model={survey} />
      </div>
    </FadeIn>
  );
};

export default RequestToPublishForm;
